// @ts-strict-ignore
import { MetaElementUsageIdentityVO, TextureAreaUsageVO, TextValueVO } from '@shared/vo/meta-element.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';
import { ArrayUtils } from '@shared/util/array-utils';
import { MathUtils } from '../common/util/math-utils';

@JsonObject('BorderDataVO')
export class BorderDataVO {
  @JsonProperty('order', 'Number')
  public order: number = undefined;

  @JsonProperty('isFullBorder', 'Boolean')
  public isFullBorder: boolean = undefined;

  @JsonProperty('color', 'Number')
  public color: number = undefined;

  public equals(obj: BorderDataVO): boolean {
    if (this === obj) {
      return true;
    }
    if (!obj) {
      return false;
    }
    if (!(obj instanceof BorderDataVO)) {
      return false;
    }
    if (this.color !== obj.color) {
      return false;
    }
    if (this.isFullBorder !== obj.isFullBorder) {
      return false;
    }
    if (this.order !== obj.order) {
      return false;
    }
    return true;
  }
}

@JsonObject('LabelTextureDataVO')
export class LabelTextureDataVO {
  @JsonProperty('id', 'String')
  public id: string = undefined;

  @JsonProperty('textureData', 'String')
  public textureData: string = undefined;

  public identity: MetaElementUsageIdentityVO = undefined;

  public clone(): LabelTextureDataVO {
    const clone: LabelTextureDataVO = new LabelTextureDataVO();
    clone.id = this.id;
    clone.textureData = this.textureData;
    clone.identity = this.identity ? this.identity.clone() : null;
    return clone;
  }
}

@JsonObject('LabelTextureDescriptionVO')
export class LabelTextureDescriptionVO {

  @JsonProperty('order', 'Number')
  public order: number = undefined;

  @JsonProperty('height', 'Number')
  public height: number = undefined;

  @JsonProperty('width', 'Number')
  public width: number = undefined;

  @JsonProperty('keepAspect', 'Boolean')
  public keepAspect: boolean = false;

  @JsonProperty('distanceToPreviousConnection', 'Number')
  public distanceToPreviousConnection: number = undefined;

  @JsonProperty('borderData', '[BorderDataVO]')
  public borderData: BorderDataVO[] = undefined;

  @JsonProperty('textValue', 'TextValueVOConverter', true)
  public textValue: TextValueVO = undefined;

  public equals(obj: LabelTextureDescriptionVO): boolean {
    if (this === obj) {
      return true;
    }
    if (!obj) {
      return false;
    }
    if (!(obj instanceof LabelTextureDescriptionVO)) {
      return false;
    }
    if (this.order !== obj.order) {
      return false;
    }
    if (!ArrayUtils.equals(this.borderData, obj.borderData)) {
      return false;
    }
    if (MathUtils.compare(this.distanceToPreviousConnection, obj.distanceToPreviousConnection) !== 0) {
      return false;
    }
    if (MathUtils.compare(this.height, obj.height) !== 0) {
      return false;
    }
    if (!this.textValue) {
      if (obj.textValue) {
        return false;
      }
    } else if (!this.textValue.equals(obj.textValue)) {
      return false;
    }
    if (MathUtils.compare(this.width, obj.width) !== 0) {
      return false;
    }
    return true;
  }
}

export class LabelTextureDescription {
  public height: number;
  public width: number;
  public keepAspect: boolean;
  public distanceToPreviousConnection: number;
  public borderData: BorderDataVO[];
  public textureAreaUsageVO: TextureAreaUsageVO;
}

@JsonObject('LabelTextureRequestVO')
export class LabelTextureRequestVO {

  @JsonProperty('id', 'String')
  public id: string = undefined;

  @JsonProperty('labelTextureDescriptions', '[LabelTextureDescriptionVO]')
  public labelTextureDescriptions: LabelTextureDescriptionVO[] = undefined;
}

@JsonObject('TextureCacheEntry')
export class TextureCacheEntry {

  @JsonProperty('labelTextureRequest', 'LabelTextureRequestVO')
  public labelTextureRequest: LabelTextureRequestVO = undefined;

  @JsonProperty('textureData', 'String')
  public textureData: string = undefined;
}
